import { createAction, isFulfilled, isPending, isRejected, type Middleware } from '@reduxjs/toolkit'

export const invalidateTenantRequests = createAction('auth/invalidateTenantRequests')

let generation = 0

export const getTenantRequestGeneration = (): number => generation

export const tenantRequestFenceMiddleware: Middleware = () => {
  const requestGenerations = new Map<string, number>()

  return (next) => (action) => {
    if (invalidateTenantRequests.match(action)) {
      generation += 1
      return next(action)
    }

    if (isPending(action)) {
      requestGenerations.set(action.meta.requestId, generation)
      return next(action)
    }

    if (isFulfilled(action) || isRejected(action)) {
      const requestGeneration = requestGenerations.get(action.meta.requestId)
      if (requestGeneration !== undefined) {
        requestGenerations.delete(action.meta.requestId)
        if (requestGeneration !== generation) return action
      }
    }

    return next(action)
  }
}
